import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CheckListsApiService } from '../../../../../../services/check-lists-api.service';

import { IChecklistTicketAnswer } from '../../../../interfaces/checklist-ticket-answer.interface';
import { IChecklistTicket } from '../../../../interfaces/checklist-ticket.interface';
import { QuestionTypeEnum } from '../../../../enums/question-type.enum';

@Component({
  selector: 'app-checklist-ticket-answers',
  templateUrl: './checklist-ticket-answers.component.html',
  styleUrls: ['./checklist-ticket-answers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChecklistTicketAnswersComponent implements OnChanges, OnDestroy {
  @Input() ticket: IChecklistTicket;
  @Input() answers: IChecklistTicketAnswer[];
  questionTypeEnum = QuestionTypeEnum;
  choiceComments = new Map<IChecklistTicketAnswer, { choice: string; comment: string }[]>();
  legacyComments = new Map<IChecklistTicketAnswer, string>();
  private questionRequests = new Subscription();

  constructor(
    private api: CheckListsApiService,
    private cdr: ChangeDetectorRef
  ) {}
  // eslint-disable-next-line max-len
  showDetails = false;
  urlRegex = '[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)?';

  ngOnChanges(): void {
    this.questionRequests.unsubscribe();
    this.questionRequests = new Subscription();
    this.choiceComments.clear();
    this.legacyComments.clear();
    for (const answer of this.answers || []) {
      if (answer.question_type !== QuestionTypeEnum.ChoicesMultipleWithComment || !answer.answer_text) {
        continue;
      }
      try {
        const comments: unknown = JSON.parse(answer.answer_text);
        if (
          !comments ||
          typeof comments !== 'object' ||
          Array.isArray(comments) ||
          !Object.entries(comments).every(([id, comment]) => /^\d+$/.test(id) && typeof comment === 'string')
        ) {
          this.legacyComments.set(answer, answer.answer_text);
          continue;
        }
        this.choiceComments.set(
          answer,
          Object.entries(comments).map(([id, comment]) => ({ choice: `Вариант ${id}`, comment }))
        );
        this.questionRequests.add(
          this.api.getQuestion(answer.question).subscribe({
            next: (question) => {
              const choices = question.answer_choices || [];
              const rows = (answer.answer_choices || []).map((selected) => {
                const choice = choices.find((item) => item.text === selected || String(item.id) === String(selected));
                return { choice: choice?.text || selected, comment: choice ? comments[choice.id] || '' : '' };
              });
              // Keep comments visible when an old choice has been removed from the question.
              for (const [id, comment] of Object.entries(comments)) {
                if (!choices.some((choice) => String(choice.id) === id && (answer.answer_choices || []).some((selected) => selected === choice.text || String(selected) === id))) {
                  rows.push({ choice: `Вариант ${id}`, comment });
                }
              }
              this.choiceComments.set(answer, rows);
              this.cdr.markForCheck();
            },
            error: () => {
              this.cdr.markForCheck();
            },
          })
        );
      } catch {
        this.legacyComments.set(answer, answer.answer_text);
      }
    }
  }

  ngOnDestroy(): void {
    this.questionRequests.unsubscribe();
  }

  toggleDetails(): void {
    this.showDetails = !this.showDetails;
  }

  isURL(str): boolean {
    const url = new RegExp(this.urlRegex, 'ig');
    return str.length < 2083 && url.test(str);
  }

  handleClick(evt: MouseEvent): void {
    evt.preventDefault();
    window.open((evt.target as HTMLLinkElement).textContent, '_blank');
  }
}
